import type { DataMockFileMeta } from '../../types';
import MockFileCard from './MockFileCard';

interface MockFilesGridProps {
    files: DataMockFileMeta[];
    onOpenFile: (file: DataMockFileMeta) => void;
}

const MockFilesGrid = ({ files, onOpenFile }: MockFilesGridProps) => (
    <div className="row">
        {files.map((file) => (
            <div key={file.path} className="col-md-6 margin-bottom-10">
                <MockFileCard file={file} onOpen={onOpenFile} />
            </div>
        ))}
    </div>
);

export default MockFilesGrid;
